export default __webpack_public_path__ + "static/media/dotted-disk.vert.ee4c618b.glsl";